import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { FormModule } from '@sdpp-web/lib/ui/form';

import {
  BrioHomeComponent,
  DisclaimerComponent,
  EnqdcHomeComponent,
  EtfComponent,
  HomeComponent,
  SmartdBancageneraliHomeComponent,
  SmartdCaisHomeComponent,
  SmartdHomeComponent
} from './components';
import { StepDirective } from './directives';

@NgModule({
  declarations: [
    StepDirective,
    BrioHomeComponent,
    DisclaimerComponent,
    EnqdcHomeComponent,
    HomeComponent,
    SmartdHomeComponent,
    SmartdCaisHomeComponent,
    SmartdBancageneraliHomeComponent,
    EtfComponent
  ],
  imports: [
    CommonModule,
    ButtonModule,
    DialogModule,
    ReactiveFormsModule,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    FormModule
  ]
})
export class HomeModule {}
